import { IPackage } from './interface'

export class Service {
  id?: string = 'new'
  description: string
  name: string
  service_providers: any[] = []
  status: string
  time: string
  type: string
  unit: string
  unitPlural: string
  image?: string
}

export class SProvider {
  districts: string[]
  id: string
  name: string
  contact_numbers: string[] = []
  packages: any[] = []
  image: string
}

export class newPackage {
  description: string
  name: string
  pricing: any[] = []
  rank: number
}

export class Pricing {
  min: number
  price: number
}
export class DistrictPricing {
  type: string
  service_provider_id: string
  district: string
  packages: IPackage[]
}
